import { useEffect, useState } from "react";
import Header from "../../components/header/header";
import ShareTable from "../../components/sharetable/shareTable";
import ActivityCard from "./activityCard";
import AddressCard from "./addressCard";
import BusinessCard from "./businessCard";
import CapitalCard from "./capitalCard";
import AddressEdit from "./AddressEdit";
import { useDispatch, useSelector } from "react-redux";
import OfficerTable from "../../components/officer/OfficerTable";
import { getCapitalList } from "../../actions/capital";
import { CAPITAL, HOLDERS_PAGE_TYPE } from "../../constants";
import { getStripeSubscriptionAction } from "../../actions/stripe";
import { useLocation, useNavigate } from "react-router-dom";
import LicensesTable from "../../components/License/LicensesTable";
import { getMyInfoDataAction } from "../../actions/myinfo";
import BusinessDetail from "./businessDetail";
import ContentLoader from "react-content-loader";
import SpeakToAdmin from "../../components/SpeakToAdmin/SpeakToAdmin";
import CompaniesCard from "./companyList/CompanyListComponent";
import { DemoSlider } from "./advisorComponents/AdvisorSlider";
import AdvisorCard from "./advisorComponents/AdvisorCard";
import PayoutListComponent from "./advisorComponents/PayoutListComponent";
import RankingTable from "./advisorComponents/RankingTable";
import { getEarningsAction } from "../../actions/advisor";
import CashBalance from "./buillionAccount/components/cashBalance";
import { getUserDashboardAction } from "../../actions/userDashboard";
import { sendMessageToAdminChat } from "../../actions/chatv2";
import PersonalAccountDetails from "./buillionAccount/components/personalAccountDetails";
import { getAllActiveCompany } from "../../actions/company";

export default function Dashboard() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    selectedCompany,
    hasPermission,
    loadingCompany,
    isDefaultCompany,
    activeCompanyList
  } = useSelector((state) => state.company);


  const { officers } = useSelector((state) => state.officers);
  const { user } = useSelector((state) => state.user);
  const { isSubscribed } = useSelector((state) => state.stripe);
  const {
    shareCapital,
    paidUpCapital,
    myInfoShareCapital,
    myInfopaidUpCapital,
    sharedCapitalIsApproved,
    sharedCapitalIsEditApproved,
    paidUpCapitalIsApproved,
    paidUpCapitalIsEditApproved,
  } = useSelector((state) => state.capital);
  const [addrModalShow, setAddrModalShow] = useState(false);
  const [capitalSlider, setCapitalSlider] = useState(true);
  const [appointSlider, setAppointSlider] = useState(true);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (location.search) {
      const code = queryParams.get("code") || null;
      const state = queryParams.get("state") || null;
      const error = queryParams.get("error") || null;
      const errorDesc = queryParams.get("error-description") || null;
      if ((code && state) || (error && state)) {
        var splitState = state.split("-");
        if (splitState.length > 0) {
          dispatch(
            getMyInfoDataAction({
              status: code ? true : false,
              code: code ? code : null,
              reason: errorDesc,
              company: splitState[0],
              errorType: error,
            })
          );
        }
      }
    }
  }, [dispatch, location]);

  useEffect(() => {
    const { id } = selectedCompany;
    if (id) {
      // dispatch(getChannelList(id));
      dispatch(getCapitalList(id));
      dispatch(getStripeSubscriptionAction(id, 1, 100));
    }
  }, [dispatch, selectedCompany, hasPermission, user]);

  const addrModalClose = () => {
    setAddrModalShow(false);
  };

  useEffect(() => {
    if (
      location.state === "inviteDirector" ||
      location.state === "appointDirector"
    ) {
      setAppointSlider(false);
    }
  }, [location]);

  const checkCompanyPermission = () => {
    var returnValue = false;
    if (user.id === selectedCompany.user) returnValue = true;

    if (!returnValue) {
      const directorList = officers?.filter((x) => x.email === user.email);
      if (directorList.length > 0) returnValue = true;
    }
    return returnValue;
  };

  useEffect(() => {
    dispatch(getEarningsAction())
    dispatch(getAllActiveCompany(1, 10))
  }, [dispatch])

  const [isEditing, setIsEditing] = useState(null);
  const [adminLoader, setAdminLoader] = useState(null);

  useEffect(() => {
    dispatch(getUserDashboardAction());
  }, [dispatch]);

  useEffect(() => {
    setAdminLoader(null);
  }, []);

  const sendMessageToAdminfunc = async (type, message, loaderType) => {
    setAdminLoader(loaderType);
    await sendMessageToAdminChat(message, selectedCompany, type, navigate, []);
  };

  return (
    <>
      <Header
        title="Dashboard"
        subtitle={
          (selectedCompany && selectedCompany.companyName
            ? selectedCompany.companyName
            : "") + `${isDefaultCompany ? "" : " Business Dashboard"}`
        }
        load={true}
      />
      <div className="container-fluid py-4 container-top landingPage paddingBottomMD">
        {loadingCompany ? (
          selectedCompany && selectedCompany.id && !isDefaultCompany ? (
            <>
              <div className="row my-0 mb-lg-4">
                <div className="col-lg-12 col-xl-12 col-md-12 mb-md-0 mb-0">
                  <BusinessCard
                    company={selectedCompany}
                    permission={checkCompanyPermission}
                  />
                </div>
              </div>

              <div className="row my-0 my-lg-4">
                <div className="col-lg-8 col-xl-8 col-md-12 mb-md-0 mb-4 minHeightVH">
                  <div className="card businessDetail">
                    <BusinessDetail company={selectedCompany} />
                  </div>

                  <div className="card mt-4">
                    <ActivityCard
                      company={selectedCompany}
                      permission={checkCompanyPermission}
                    />
                  </div>
                  <div className="card mt-4">
                    <AddressCard permission={checkCompanyPermission} />
                  </div>
                  <div className="card mt-4">
                    <LicensesTable type={HOLDERS_PAGE_TYPE.DASHBOARD} />
                  </div>
                  <div className="capitalHolder">
                    {/* <h5 className="sliderHeader">Capital</h5> */}
                    <span
                      className={`sliderText ${capitalSlider ? "active" : ""}`}
                      onClick={() => setCapitalSlider(true)}
                    >
                      Share capital
                    </span>
                    <span
                      className={`sliderText ${!capitalSlider ? "active" : ""}`}
                      onClick={() => setCapitalSlider(false)}
                    >
                      Paid-up capital
                    </span>
                    {capitalSlider ? (
                      <CapitalCard
                        company={selectedCompany}
                        capitalType={CAPITAL.shared}
                        capital={shareCapital}
                        myInfoCapital={myInfoShareCapital}
                        capitalIsApproved={sharedCapitalIsApproved}
                        capitalIsEditApproved={sharedCapitalIsEditApproved}
                        title="Share capital"
                        subtitle="Share capital amount"
                      />
                    ) : (
                      <CapitalCard
                        company={selectedCompany}
                        capitalType={CAPITAL.paidUp}
                        capital={paidUpCapital}
                        myInfoCapital={myInfopaidUpCapital}
                        capitalIsApproved={paidUpCapitalIsApproved}
                        capitalIsEditApproved={paidUpCapitalIsEditApproved}
                        title="Paid-up capital"
                        subtitle="Paid-up capital Amount"
                      />
                    )}
                  </div>

                  <div className="capitalHolder">
                    {/* <h5 className="sliderHeader">Insert Label Here</h5> */}
                    <span
                      className={`sliderText ${appointSlider ? "active" : ""}`}
                      onClick={() => setAppointSlider(true)}
                    >
                      Shareholders
                    </span>
                    <span
                      className={`sliderText ${!appointSlider ? "active" : ""}`}
                      onClick={() => setAppointSlider(false)}
                    >
                      Directors
                    </span>
                    {appointSlider ? (
                      <div className="row my-0 my-md-4">
                        <div
                          className={`col-lg-${isSubscribed !== null && !isSubscribed ? "12" : "12"
                            } col-xl-${isSubscribed !== null && !isSubscribed ? "12" : "12"
                            } col-md-12 mb-md-0 mb-4 mt-4 mt-md-0`}
                        >
                          <ShareTable type={HOLDERS_PAGE_TYPE.DASHBOARD} />
                        </div>
                      </div>
                    ) : (
                      <div className="row my-0 my-md-4 officer-section">
                        {/* isSubscribed !== null && !isSubscribed ? "8" : "12" old */}
                        <div
                          className={`col-lg-${isSubscribed !== null && !isSubscribed ? "12" : "12"
                            } col-xl-${isSubscribed !== null && !isSubscribed ? "12" : "12"
                            } col-md-12 mb-md-0 mb-4 mt-4 mt-md-0`}
                        >
                          <OfficerTable type={HOLDERS_PAGE_TYPE.DASHBOARD} />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-xl-4 mt-lg-0 mt-md-3 mt-xl-0 mt-0 mt-lg-4 mb-4 mb-lg-0">
                  <div className="card">
                    <div className="card-header card-border">
                      <div className="card-body full-background card-formalize">
                        <h2 className="business-font mt-0">
                          {" "}
                          We can build holding companies for you
                        </h2>
                        <h6 className="mb-0 text-sm table-heading mt-3">
                          Sit back to enjoy owning from Singapore:
                        </h6>
                        <ul>
                          <li>Investment businesses like FOs and SPVs</li>
                          <li>Active businesses like consulting</li>
                          <li>Regulated businesses like crypto and funds</li>
                        </ul>

                        <div className="buttonLink">
                          <SpeakToAdmin />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row">
                <div className="col-12 col-md-12">
                  <DemoSlider />
                </div>
              </div>
              {user?.isAdvisor &&
                <AdvisorCard />
              }
              <div className="row mb-3">
                <div className="col-12">
                  <PersonalAccountDetails
                    isEditing={isEditing}
                    setIsEditing={(value) => setIsEditing(value)}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <CashBalance isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} sendMessageToAdmin={sendMessageToAdminfunc} adminLoader={adminLoader} />
                </div>
                {user?.isAdvisor &&
                  <div className=" col-12 col-md-6 ">
                    <div className='accountBorderSection'>
                      <PayoutListComponent />
                    </div>
                  </div>
                }
                {activeCompanyList?.length > 0 &&
                  <div className=" col-12 col-md-6 ">
                    <div className='accountBorderSection'>
                      <CompaniesCard />
                    </div>
                  </div>
                }
                {user?.isAdvisor &&
                  <div className="col-12 col-md-6">
                    <div className='accountBorderSection'>
                      <RankingTable />
                    </div>
                  </div>
                }
              </div>
            </>
          )
        ) : (
          <div className="row">
            <div className="col-md-2">
              <ContentLoader width="100%" height={120}>
                <rect x="0" y="0" rx="10" ry="10" width="100%" height="120" />
              </ContentLoader>
            </div>
            <div className="col-md-6">
              <ContentLoader width="100%" height={120}>
                <rect x="0" y="0" rx="10" ry="10" width="100%" height="120" />
              </ContentLoader>
            </div>
            <div className="col-md-4">
              <ContentLoader width="100%" height={120}>
                <rect x="0" y="0" rx="10" ry="10" width="100%" height="120" />
              </ContentLoader>
            </div>

            <div className="col-md-8 bottomDashSkelton">
              <ContentLoader width="100%" height={350}>
                <rect x="0" y="0" rx="10" ry="10" width="100%" height="350" />
              </ContentLoader>
            </div>
            <div className="col-md-4 bottomDashSkelton">
              <ContentLoader width="100%" height={350}>
                <rect x="0" y="0" rx="10" ry="10" width="100%" height="350" />
              </ContentLoader>
            </div>
          </div>
        )}
      </div>

      <AddressEdit
        addrModalShow={addrModalShow}
        addrModalClose={addrModalClose}
      />
    </>
  );
}
